import React from 'react';
import { MapPin, Clock, CircleDollarSign, ShieldCheck, Tag, Timer } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: MapPin,
      title: 'Técnicos Locais',
      description: 'Técnicos especializados na sua zona para um atendimento mais rápido e personalizado'
    },
    {
      icon: Clock,
      title: 'Atendimento 24h',
      description: 'Disponíveis todos os dias para emergências e agendamentos de serviços'
    },
    {
      icon: CircleDollarSign,
      title: 'Orçamento Gratuito',
      description: 'Avaliação e orçamento sem qualquer custo ou compromisso da sua parte'
    },
    {
      icon: ShieldCheck,
      title: 'Serviço com Garantia',
      description: 'Todos os nossos serviços incluem garantia de qualidade e satisfação'
    },
    {
      icon: Tag,
      title: 'Preços Transparentes',
      description: 'Sem custos ocultos. O preço acordado é o preço final que paga'
    },
    {
      icon: Timer,
      title: 'Resposta Rápida',
      description: 'Contactamos em menos de 2 horas após receber o seu pedido'
    }
  ];

  const [current, setCurrent] = React.useState(0);
  const [isDesktop, setIsDesktop] = React.useState(false);
  const [paused, setPaused] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const update = () => setIsDesktop(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);

  // Build slides responsivamente: 1 item por slide no mobile, 2 no desktop
  const slides = React.useMemo(() => {
    if (!isDesktop) return reasons.map((r) => [r]);
    const chunked: typeof reasons[][] = [] as any;
    for (let i = 0; i < reasons.length; i += 2) {
      chunked.push(reasons.slice(i, i + 2));
    }
    return chunked;
  }, [isDesktop]);

  const next = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  // Autoplay - carrossel automático
  React.useEffect(() => {
    if (paused) return;
    const id = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => window.clearInterval(id);
  }, [slides.length, paused]);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Título compacto */}
        <div className="text-center mb-8">
          <h2 className="text-3xl lg:text-4xl font-bold tracking-tight text-gray-900 mb-2">
            O Diferencial
          </h2>
          <p className="text-gray-700 text-lg">
            Porquê Escolher a PLUMBERS NOW
          </p>
        </div>

        {/* Slider */}
        <div className="relative" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
          {/* Track */}
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500"
              style={{ transform: `translateX(-${current * 100}%)` }}
            >
              {slides.map((group, slideIdx) => (
                <div key={slideIdx} className="min-w-full px-2">
                  <div className={`grid ${isDesktop ? 'lg:grid-cols-2' : ''} gap-6 lg:gap-8 max-w-5xl mx-auto`}>
                    {group.map((reason, index) => (
                      <div
                        key={index}
                        className={`bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-all duration-300 ${
                          index % 2 === 0 && isDesktop ? 'lg:flex lg:flex-row-reverse lg:items-center' : ''
                        }`}
                      >
                        <div className={`flex ${index % 2 === 0 && isDesktop ? 'lg:justify-end' : 'lg:justify-start'} justify-center mb-6 lg:mb-0`}>
                          <div className="w-20 h-20 rounded-full bg-[#2563eb] flex items-center justify-center shadow-lg hover:bg-[#1e40af] transition-all duration-300 transform hover:scale-110 ring-4 ring-[#2563eb]/20">
                            <reason.icon className="w-10 h-10 text-white" />
                          </div>
                        </div>
                        <div className="text-center lg:text-left lg:px-6">
                          <h3 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">
                            {reason.title}
                          </h3>
                          <p className="text-gray-700 leading-relaxed text-sm">
                            {reason.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Arrows e dots escondidos para manter como faixa compacta */}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
